module.exports = __webpack_public_path__ + "img/self-service-5.58df18d2.svg";